// src/components/BrandIcons.jsx

export function InstagramIcon(props) {
    return (
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
            <rect x="3" y="3" width="18" height="18" rx="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.3" cy="6.7" r="0.6" fill="currentColor" stroke="none" />
        </svg>
    );
}

export function AppleIcon(props) {
    return (
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
            <path d="M16.365 1.43c0 1.14-.462 2.09-1.03 2.75-.623.724-1.634 1.28-2.512 1.21-.11-1.09.44-2.22 1.03-2.9.646-.75 1.79-1.32 2.512-1.06zM20.94 17.19c-.53 1.22-.78 1.77-1.46 2.85-.95 1.51-2.29 3.39-3.95 3.41-1.48.02-1.86-.96-3.87-.95-2.01.01-2.43.97-3.91.95-1.66-.02-2.93-1.72-3.88-3.23-1.79-2.72-2.31-6.92-.66-9.32 1.16-1.71 2.99-2.72 4.7-2.72 1.71 0 2.79.94 4.2.94 1.36 0 2.2-.94 4.2-.94 1.5 0 3.09.82 4.24 2.24-3.73 2.04-3.12 7.35 0 8.37z" />
        </svg>
    );
}
